import { isTimesPostSettings } from "./publicationIdentity.js";

// Measured bounds of the current 1920x600 asset: x162..1754, y158..407.
// Keep a six-pixel source buffer when framing the sticky version. Match only
// this asset so a replacement with different padding is never cropped blindly.
const paddedAsset = "/api/media/2026/10/efca8b7d-f3cc-4476-aa68-83bb56929a5a.webp";
export function hasPaddedTimesPostMasthead(settings, image) {
  if (!isTimesPostSettings(settings) || !image) return false;
  try { return new URL(image, "https://timespost.co.za").pathname === paddedAsset; }
  catch { return false; }
}

export const timesPostStickyCrop = {
  width: `${1920 / 1605 * 100}%`, maxWidth: "none", height: "auto",
  left: `${-156 / 1605 * 100}%`, top: `${-152 / 262 * 100}%`,
};

// Owner-approved reversible mask: remove only the h's descending flourish.
// Coordinates refer to the identified 1920x600 artwork, not the img element.
const flourishMask = `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 600"><path fill="white" fill-rule="evenodd" d="M0 0H1920V600H0Z M375 359H405V412H375Z"/></svg>')}")`;
export function timesPostMastheadMask(settings, image) {
  return hasPaddedTimesPostMasthead(settings, image) ? flourishMask : "none";
}
